import { API } from '@/api';

export const classes = {
  card: 'h-full grow min-w-[300px] overflow-x-auto px-3 pt-0 rounded-2xl border border-solid border-black/10 bg-white/[0.82] shadow-aurora-card dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  titleWrapper: 'grow-0 place-between py-2 px-6',
  newNoteWrapper: 'pb-0 px-5 shrink-0',
  message: 'mt-4 text-center text-taupe-1 text-base dark:text-mauve-3',
  timeline: 'flex-1 grow overflow-y-auto pb-4 px-5 shrink-0',
  addNoteButton: 'text-brand-accent dark:text-brand-accent-dark',
};

export async function createFileNote(fileId: number, content: string) {
  return API.Files.addNoteToFile(fileId, {
    note: { content },
  });
}
